<template>
  <section>
    <div class="popups">
      <b-sidebar
        v-model="showFilters"
        right
        shadow
        backdrop
        bg-variant="white"
        no-header
      >
        <template>
          <div class="container sidebar-header">
            <b-row>
              <div class="col">
                <b-button
                  variant="primary"
                  @click="
                    applyFilters();
                    loadItems();
                    showFilters = false;
                  "
                  >Apply</b-button
                >
              </div>

              <div class="col-auto text-right">
                <b-button
                  type="reset"
                  variant="outline-danger"
                  @click="resetFormFilters()"
                >
                  Reset
                </b-button>
                <b-button
                  variant="outline-secondary"
                  class="ml-1"
                  @click="
                    showFilters = false;
                    formFilters = { ...itemsFilters };
                  "
                >
                  Cancel
                </b-button>
              </div>
            </b-row>
          </div>

          <div class="px-3 py-2">
            <b-form-group label="Storefront:">
              <b-v-select
                v-model="formFilters.projectId"
                :searchable="true"
                :options="projectsFilter"
              />
            </b-form-group>

            <b-form-group label="Tracking Number:">
              <b-form-input v-model="formFilters.trackingNumber" />
            </b-form-group>
            <b-form-group label="Carrier:">
              <b-form-input v-model="formFilters.carrier" />
            </b-form-group>
            <b-form-group label="Service:">
              <b-form-input v-model="formFilters.service" />
            </b-form-group>

            <b-form-group label="Status:">
              <b-form-select v-model="formFilters.status" :options="shipmentStatusOpts">
              </b-form-select>
            </b-form-group>

            <b-form-group
              label="From Ship Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.shipDateStart"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="shipDateStart"

              />
            </b-form-group>
            <b-form-group  class="border-bottom mb-1 pb-2"  label="To Ship Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.shipDateEnd"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="shipDateEnd"

              />
            </b-form-group>

            <b-form-group
              label="From Modify Date:"
              description="From Date must be before To Date"
            >
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.modifyDateStart"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="modifyDateStart"

              />
            </b-form-group>
            <b-form-group  class="border-bottom mb-1 pb-2"  label="To Modify Date:">
              <b-form-datepicker
                :reset-button="true"
                v-model="formFilters.modifyDateEnd"
                class="form-control flatpickr-input"
                placeholder="Select date"
                name="modifyDateEnd"

              />
            </b-form-group>
          </div>
        </template>
      </b-sidebar>
    </div>

    <div class="header">
      <div class="header-body">
        <div class="row align-items-end">
          <div class="col">
            <h1 class="header-title">
              Storefront Shipments
            </h1>
            <ActiveFiltersCard :itemsFilters="itemsFilters" :resetFilterWithKey="resetFilterWithKey" :loadItems="loadOrderItems">
              <template v-slot:filterWrap(quickView)>
              </template>
              <template v-slot:filterWrap(projectId)="data">
                <span class="badge badge-primary mr-2">
                    <b>Storefront: </b>
                    <span><span
                        v-if="myProjects && myProjects.find(a => a.id == data.item)"
                        >{{ myProjects.find(a => a.id == data.item).name }}</span
                      >
                      <span v-else>-</span></span>
                      <span
                        class="fa fa-times fa-1x ml-2"
                        @click="
                          resetFilterWithKey('projectId');
                          loadOrderItems();
                        "
                    ></span>
                </span>
              </template>
            </ActiveFiltersCard>
          </div>
          <div class="col-auto">
            <button
              @click="ExportPage()"
              class="btn btn-success mr-2"
              :disabled="downloadPending"
            >
              <b-spinner small v-if="downloadPending"></b-spinner>
              <i class="fa fa-cloud-download mr-2"></i>
              Export
            </button>
            <b-button variant="primary" @click="showFilters = !showFilters">
              <i class="fa fa-filter mr-2"></i>
              Filters
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <TableListing
      class="mb-0"
      :loading-page="loadingItems"
      :failed-loading="failedLoadItems"
      head-variant="dark"
      :items.sync="items"
      :fields.sync="fields"
      :pagination.sync="pagination"
      :options.sync="tableOptions"
      v-on:pagination-changed="loadItems"
    >
      <template v-slot:cell(projectId)="data">
        <span
          v-if="myProjects && myProjects.find(a => a.id == data.item.projectId)"
          >{{ myProjects.find(a => a.id == data.item.projectId).name }}</span
        >
        <span v-else>-</span>
      </template>
      <template v-slot:cell(orderNumber)="data">
        <CopyText :text="data.item.orderNumber">
          <router-link
            class="badge badge-warning"
            :to="{
              name: 'Common.OrderDetails',
              query: { id: data.item.orderId }
            }"
          >
            {{ data.item.orderNumber }}
          </router-link>
        </CopyText>
      </template>
      <template v-slot:cell(trackingNumber)="data">
        <div>
          <CopyText :text="data.item.trackingNumber">
            <span v-if="data.item.trackingUrl"><a target="_blank"
              class="badge"
                :class="{
                  'badge-danger': data.item.isReturnLabel,
                  'badge-secondary': !data.item.isReturnLabel
                }"
              :href="data.item.trackingUrl">{{ data.item.trackingNumber }}</a></span>
            <span v-else-if="data.item.trackingNumber">
              <a :href="'https://t.17track.net/en#nums=' + data.item.trackingNumber"
                target="_blank"
                class="badge"
                :class="{
                  'badge-danger': data.item.isReturnLabel,
                  'badge-secondary': !data.item.isReturnLabel
                }"
                >{{ data.item.trackingNumber }}</a>
            </span>
            <span v-else>
              <span>-</span>
            </span>
          </CopyText>
        </div>
      </template>
      <template v-slot:cell(status)="data">
        <div>
          <a target="_blank" :to="data.item.trackingUrl" class="d-inline-block">
            <span  class="badge badge-secondary" v-if="data.item.status == 'Created'">Created</span>
              <span  class="badge badge-warning" v-else-if="data.item.status == 'InTransit'">InTransit</span>
              <span  class="badge badge-info" v-else-if="data.item.status == 'Shipped'">Shipped</span>
              <span  class="badge badge-success" v-else-if="data.item.status == 'Delivered'">Delivered</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'Cancelled'">Cancelled</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'DamagedInTransit'">Damaged In Transit</span>
              <span  class="badge badge-danger" v-else-if="data.item.status == 'LostInTransit'">LostInTransit</span>
              <span class="badge badge-secondary" v-else>{{ data.item.status }}</span>
          </a>
          <div class="d-inline-block ml-1">
            <b-button
                :id="'tracking-events-btn-' + data.index"
                :disabled="!data.item.events || !data.item.events.length"
                class="btn-sml"
                variant="secondary"
              >
                <i class="fa fa-area-chart"></i>
              </b-button>
              <b-popover
                :target="'tracking-events-btn-' + data.index"
                triggers="hover"
                placement="left"
                title="Tracking Updates"
              >
                <TrackingEvents :events="data.item.events" max-height="260px" />
              </b-popover>
          </div>
        </div>
      </template>
        <template v-slot:cell(carrierCode)="data">
          <div>
            <span v-if="data.item.carrierCode">{{ data.item.carrierCode  }}</span>
            <span v-else>-</span>
          </div>
          <div class="border-top" v-if="data.item.serviceCode">
            <span class="text-secondary">{{ data.item.serviceCode }}</span>
          </div>
        </template>
        <template v-slot:cell(dimensions)="data">
          <div v-if="data.item.dimensions && data.item.dimensions.units">
            <span>W: {{ data.item.dimensions.width }} {{ data.item.dimensions.units }}</span> |
            <span>H {{ data.item.dimensions.height }} {{ data.item.dimensions.units }}</span> |
            <span>L: {{ data.item.dimensions.length }} {{ data.item.dimensions.units }}</span>
          </div>
        </template>

        <template v-slot:cell(weight)="data">
          <div v-if="!is('brand-user') && data.item.weight && data.item.weight.value && data.item.grossWeight && data.item.grossWeight.units && data.item.grossWeight.value && parseFloat(data.item.weight.value) > parseFloat(data.item.grossWeight.value)">
            <b>Gross (DIMW): </b><span>{{ parseFloat(data.item.weight.value).toFixed(2) }}</span> (Orig: <span>{{ parseFloat(data.item.grossWeight.value).toFixed(2) }}</span>) {{ data.item.weight.units }}
          </div>
          <div v-else-if="data.item.weight && data.item.weight.units && data.item.weight.value">
            <b>Gross: </b><span>{{ parseFloat(data.item.weight.value).toFixed(2) }}</span> {{ data.item.weight.units }}
          </div>
          <div class="border-top" v-if="data.item.packagingWeight && data.item.packagingWeight.units && data.item.packagingWeight.value">
            <b>Packaging: </b><span>{{ parseFloat(data.item.packagingWeight.value).toFixed(2) }}</span> {{ data.item.packagingWeight.units }}
          </div>
        </template>

        <template v-slot:cell(createDate)="data">
          <span>{{
            data.item.createDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMM Do, h:mm a')
          }}</span>
        </template>
        <template v-slot:cell(modifyDate)="data">
          <span>{{
            data.item.modifyDate | moment('add', $store.getters['account/getUserTimezonePCDiff'] + ' hours', 'MMM Do, h:mm a')
          }}</span>
        </template>
        <template v-slot:cell(receiveDate)="data">
          <span v-if="data.item.receiveDate && !data.item.receiveDate.endsWith('Z')">
            {{ (data.item.receiveDate + 'Z') | moment('MMM Do YY, h:mm a') }}
          </span>
          <span v-else-if="data.item.receiveDate">
            {{ data.item.receiveDate | moment('MMM Do YY, h:mm a') }}
          </span>
          <span v-else>-</span>
        </template>
    </TableListing>
  </section>
</template>

<script>
import { TableListing, ActiveFiltersCard } from '@/views/components/custom';
import { crudMixinGen, myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  name: 'Storefronts.StorefrontShipments.Index',
  mixins: [crudMixinGen('storefrontShipments'), myCommonDataMixin],
  components: {
    TableListing,
    ActiveFiltersCard
  },
  computed: {
  },

  data: () => ({
    downloadPending: false,
    fields: [
      { key: 'projectId', label: 'Storefront', sortable: false },
      { key: 'orderNumber', label: 'Order #', sortable: false },
      { key: 'createDate', label: 'Ship Date', sortable: false },
      { key: 'trackingNumber', label: 'Tracking Number', sortable: false },
      { key: 'status', label: 'Status', sortable: false },
      { key: 'carrierCode', label: 'Carrier', sortable: false },
      { key: 'dimensions', label: 'DIMs', sortable: false },
      { key: 'weight', label: 'Weight', sortable: false },
      { key: 'modifyDate', label: 'Last Change', sortable: false },
      //{ key: 'deliveryStatus', label: 'Carrier State', sortable: false },
      { key: 'receiveDate', label: 'Delivered At', sortable: false },
      //{ key: 'id', label: 'Action', sortable: false }
    ],
    shipmentStatusOpts: [
      { text: 'All', value: '' },
      { text: 'Returned', value: 'Returned' },
      { text: 'Damaged In Transit', value: 'DamagedInTransit' },
      { text: 'Lost In Transit', value: 'LostInTransit' },
      { text: 'Created', value: 'Created' },
      { text: 'In Transit', value: 'InTransit' },
      { text: 'Delivered', value: 'Delivered' },
      { text: 'Cancelled', value: 'Cancelled' },
      { text: 'Unknown', value: 'Unknown' },
    ]
  }),
  mounted() {
    this.loadItems();
  },

  methods: {
    ExportPage() {
      let downloadFileUrl = process.env.VUE_APP_API_URL + '/download/storefront-shipments';
      let params = this.itemsFilters;

      let form_data = new FormData();
      for (var key in params) {
        form_data.append(key, params[key]);
      }
      this.downloadPending = true;
      this.$http.post(downloadFileUrl, form_data, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        responseType: 'blob'
      })
        .then(response => {
          const href = window.URL.createObjectURL(response.data);
          let fileName = 'storefront_shipments.xlsx';
          const anchorElement = document.createElement('a');

          anchorElement.href = href;
          anchorElement.download = fileName;

          document.body.appendChild(anchorElement);
          anchorElement.click();

          document.body.removeChild(anchorElement);
          window.URL.revokeObjectURL(href);
          this.downloadPending = false;
        })
        .catch(error => {
          this.downloadPending = false;
          this.$swal('Error', 'Error downloading file', 'error');
          console.log('error: ', error);
        });
    }
  }
};
</script>
